/*
====================================================================
                        Clase TokenEntity
====================================================================
Esta clase representa una entidad que encapsula el token de autenticación 
de un usuario y proporciona métodos para validar dicho token.

- Almacena el token de autenticación.
- Almacena si el token es válido o no (isValido).
- Almacena si se está validando el token (isValidando).
====================================================================
*/

// ------------------------------------------------------------------
//                       DEFINICIÓN DE LA CLASE
// ------------------------------------------------------------------
/**
 * Clase que representa una entidad de token.
 * 
 * Esta clase encapsula el token de autenticación y su estado de validez.
 */
class TokenEntity {
    /**
     * Constructor de la clase TokenEntity.
     * 
     * @param {string} token - El token de autenticación.
     * @param {boolean} isValido - Indica si el token es válido.
     * @param {boolean} isValidando - Indica si se está validando el token.
     */
    constructor(token = "", isValido = false, isValidando = true) {
      this.token = token.trim();
      this.isValido = isValido;
      this.isValidando = isValidando;
    }
  
    /**
     * Método para validar si el token es válido.
     * 
     * Este método simula la validación del token.
     * 
     * @returns {boolean} `true` si el token es válido, de lo contrario `false`.
     */
    validarToken() {
      // Aquí podrías implementar la lógica real para validar el token.
      // Por simplicidad, en este ejemplo, solo verificamos si el token no está vacío.
      if (this.token) {
        this.isValido = true;
      } else {
        this.isValido = false;
      }
      return this.isValido;
    }
  
    /**
     * Método para iniciar la validación del token.
     * 
     * Este método simula el proceso de validación del token.
     */
    iniciarValidacion() {
      this.isValidando = true;
      // Simula un proceso de validación
      setTimeout(() => {
        this.validarToken();
        this.isValidando = false;
      }, 1000);  // Simulación de un retraso de 1 segundo en la validación
    }
  
    /**
     * Método para resetear el token y su estado de validez.
     */
    resetearToken() {
      this.token = "";
      this.isValido = false;
      this.isValidando = false;
    }
  }
  
  // ------------------------------------------------------------------
  //                            EXPORTS
  // ------------------------------------------------------------------
  // Exportación de la clase para su uso en otros módulos de la aplicación.
  
  export default TokenEntity;
  